module.exports = __webpack_public_path__ + "static/media/018-dominican-republic.28be175c.svg";